import { Configuration, LogLevel } from '@azure/msal-browser'
import { config } from '../config'

/**
 * MSAL configuration for Entra External ID (CIAM tenant).
 * Note: authority uses .ciamlogin.com, not .b2clogin.com (that's the old B2C).
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: config.entraClientId,
    authority: `https://${config.entraTenantId}.ciamlogin.com/${config.entraTenantId}/v2.0`,
    knownAuthorities: [`${config.entraTenantId}.ciamlogin.com`],
    redirectUri: window.location.origin + '/',
    postLogoutRedirectUri: window.location.origin + '/',
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // sessionStorage: tokens cleared when browser tab closes (safer than localStorage)
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        if (level === LogLevel.Error) console.error('[MSAL]', message)
        else if (level === LogLevel.Warning) console.warn('[MSAL]', message)
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
}

/**
 * Scopes to request during sign-in. Includes openid/profile/email so the
 * ID token contains the claims we cache in the API's customer_identities row.
 */
export const loginRequest = {
  scopes: [config.apiScope, 'openid', 'profile', 'email'],
}

/**
 * Scopes to request when acquiring an access token for API calls.
 * Only the API scope — the standard OIDC scopes go in the ID token, not the access token.
 */
export const apiTokenRequest = {
  scopes: [config.apiScope],
}

/**
 * v1.2.0: token request for schedule changes. Requested only when the
 * customer submits or cancels a window, never at sign-in, so a problem with
 * the write scope can never stop the dashboard from loading.
 */
export const apiWriteTokenRequest = {
  scopes: [config.apiWriteScope],
}
